var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-base',{on:{"onPrev":function($event){return _vm.onPrev()},"onNext":function($event){return _vm.onNext()}}},[_c('review-your-answers-page',{attrs:{"questionResults":_vm.questionResults,"step":_vm.step},on:{"pageHasError":_vm.handlePageHasError}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }